module.exports = __webpack_public_path__ + "static/Li-Ion-Battery-Pack-1-be35d488da4b362215b608e2488dd3e8.jpg";